import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Checkpoint } from '../../../../../models/localization/checkpoint';
import { MessageService } from 'brainloper-ui';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { CheckpointService } from 'src/app/services/checkpoint.service';

@Component({
    selector: 'app-control-pointer',
    templateUrl: './control-pointer.component.html',
    styleUrls: ['./control-pointer.component.scss'],
    standalone: false
})
export class ControlPointerComponent implements OnInit {
  @Input() controlPointer: Checkpoint[] = [];
  @Input() viewAddCkeckpoint: boolean = true;
  @Input() isHistorical: boolean = false;
  @Input() isRoute: boolean = false;
  @Input() colorComplete: string;
  @Input() colorIncomplete: string;
  @Input() colorPending: string;
  @Output() edit = new EventEmitter<Checkpoint>();
  @Output() delete = new EventEmitter<any>();
  @Output() selectPointer = new EventEmitter<Checkpoint>();
  @Output() view = new EventEmitter<Checkpoint>();
  @Output() addCheckpoint = new EventEmitter<Checkpoint>();

  public EndpointDictionary = EndpointDictionary;

  constructor(
    private message: MessageService,
    private deleteGenericService: DeleteGenericService,
    private checkpointService: CheckpointService
  ) {}

  ngOnInit(): void {
      this.checkpointService.assignButtonTypeToLastComplete(this.controlPointer);      
   
  }

  editCard(pointer: Checkpoint) {
    this.edit.emit(pointer);
  }
  deleteCard(index: number, pointer: Checkpoint) {
    if (index >= 0 && index < this.controlPointer.length) {
      this.message
        .Warning(
          'Advertencia',
          `Desea eliminar el punto de control ${pointer.name}`,
          true
        )
        .then(async (res) => {
          if (res) {
            this.message.openLoading('Cargando', 'Eliminando punto de control');
            await this.deleteGenericService.deleteWhitoutWarning(
              EndpointDictionary.Travelhistory.DELETE_CHECKPOINT_TRAVEL,
              pointer.id
            );
            if (pointer.additionalCheckpoint === 1) {
              this.controlPointer.splice(index, 1);
            } else {
              this.controlPointer[index].complete = false;
              this.controlPointer[index].buttonsType = [1];
              delete this.controlPointer[index].background;
            }
            this.checkpointService.assignButtonTypeToLastComplete(
              this.controlPointer
            );
            this.message.closeLoading();
          }
        });
    }
  }

  $selectPointer(index: number, pointer: Checkpoint) {
    pointer.index = index;
    if (index === this.controlPointer.length - 1) {
      pointer.id = -2;
    }
    this.selectPointer.emit(pointer);
  }

  viewDetail(index: number, pointer: Checkpoint) {
    this.view.emit(pointer);
  }

  addCheckpointDialog(index: number) {
    const checkpoint = new Checkpoint();
    checkpoint.index = index;
    this.addCheckpoint.emit(checkpoint);
  }
}
